import script from "./VitaBeruLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaBeruLayout.vue?vue&type=script&setup=true&lang=ts"

import "./VitaBeruLayout.vue?vue&type=style&index=0&id=6b8af547&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b8af547"]])

export default __exports__